import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`If you find malware in an npm package (either yours or someone else's), you can report it to the npm Security team to help keep the Javascript ecosystem safe.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` Vulnerabilities in npm packages should be reported directly to the package maintainers. We strongly advise doing this privately. You can find contact information about package maintainers with `}<inlineCode parentName="p">{`npm owner ls <package-name>`}</inlineCode>{`. If the source code is hosted on GitHub please refer to the repository's `}<a parentName="p" {...{
          "href": "https://docs.github.com/en/free-pro-team@latest/github/managing-security-vulnerabilities/adding-a-security-policy-to-your-repository#about-security-policies"
        }}>{`Security Policy`}</a>{`.`}</p>
    </Note>
    <h2>{`How npm Security handles malware`}</h2>
    <p>{`Malware is a major concern for npm Security and we have removed hundreds of malicious packages from the registry. For every malware report we receive, npm Security takes the following actions:`}</p>
    <ol>
      <li parentName="ol">{`Confirm validity of the report.`}</li>
      <li parentName="ol">{`Remove the package from the registry.`}</li>
      <li parentName="ol">{`Publish a security placeholder for the package.`}</li>
      <li parentName="ol">{`Publish a security advisory alerting the community.`}</li>
    </ol>
    <p>{`As part of our process we determine whether the user account who uploaded the package should be banned. We also cooperate with 3rd parties when applicable.`}</p>
    <h2>{`Reporting malware`}</h2>
    <ol>
      <li parentName="ol">{`Gather information about the malware.`}</li>
      <li parentName="ol">{`On the package page, click `}<strong parentName="li">{`Report malware`}</strong>{`.`}</li>
      <li parentName="ol">{`On the malware report page, provide information about yourself and the malware:`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`Name:`}</strong>{` Your name.`}</li>
          <li parentName="ul"><strong parentName="li">{`Email address:`}</strong>{` An email address the npm Security team can use to contact you.`}</li>
          <li parentName="ul"><strong parentName="li">{`Package name:`}</strong>{` The name of the package that contains the malware.`}</li>
          <li parentName="ul"><strong parentName="li">{`Package version:`}</strong>{` The version of the package that contains the malware. Include all affected versions.`}</li>
          <li parentName="ul"><strong parentName="li">{`Description of the malware:`}</strong>{` A brief description of the malware and its effects. Include references, commits, and/or code examples that would help our researchers confirm the report.`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Send Report`}</strong>{`.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      